var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpActiveIcon = function SvgThumbsUpActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.888 18.608 1.255-8.25a1.85 1.85 0 0 0-.324-1.374 1.82 1.82 0 0 0-1.195-.734h-5.45V4.583c0-.729-.287-1.428-.798-1.944a2.71 2.71 0 0 0-1.926-.806l-3.617 8.25v10.083h10.23c.44.008.867-.146 1.202-.433.336-.287.557-.686.623-1.125M5.167 20.167v-10H3.47a1.58 1.58 0 0 0-1.158.537c-.307.34-.479.8-.479 1.28v6.366c0 .479.172.938.479 1.279.306.34.723.533 1.158.538z"
  })));
};
export default SvgThumbsUpActiveIcon;